import AddSvg from '../../../assets/add.svg?react';
import { IconProps } from '../../types/IconProps';

export function Add({ size = 20, ...props }: IconProps) {
  return <AddSvg data-testid="add-icon" width={size} height={size} {...props} />;
}

export default Add;
